import { StylesConfig, Theme } from "react-select";
import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";
import { SearchBarOption } from "utils/fuzzyApiHelpers";

export const SIDEBAR_WIDTH = "24em";

export const StyledSidebar = styled.nav`
  flex: 0 0 ${SIDEBAR_WIDTH};
  background-color: ${colours.lightGrey};
  padding-top: 20px;
  padding-bottom: 60px;
  font-weight: ${fonts.semibold};

  .search-bar {
    padding: 0 16px 0 24px;
  }
`;

export const StyledOption = styled.div`
  font-size: ${fonts.small};
  box-shadow: none;
  cursor: pointer;
  padding: 8px 40px 8px;
  color: ${colours.darkGrey};

  :hover {
    background-color: ${colours.highlightGrey};
  }

  &&.is-active {
    background-color: ${colours.focusBlue};
    color: ${colours.white};
  }
`;

export const StyledCard = styled.div`
  background-color: ${colours.transparent};
`;

export const StyledGettingStartedContainer = styled.div`
  margin-top: 24px;
`;

export const StyledHeader = styled.div`
  && {
    font-size: ${fonts.medium};
    box-shadow: none;
    cursor: pointer;
    border-radius: 0;
    padding: 8px 0 8px 5px;

    :hover {
      background-color: ${colours.highlightGrey};
    }

    &&.top-bottom-border {
      border-bottom: 1px solid ${colours.mediumGrey};
      border-top: 1px solid ${colours.mediumGrey};
    }

    &&.is-active {
      background-color: ${colours.focusBlue};
      border-width: 0;

      .card-header-title {
        color: ${colours.white};
      }
    }

    .card-header-title {
      font-weight: ${fonts.semibold};
    }
  }
`;

export const StyledButton = styled.button`
  padding-bottom: 0;
  padding-top: 0;
`;

export const Title = styled.span`
  padding: 0 16px 0 24px;
  color: ${colours.darkGrey};
`;

export const StyledDiv = styled.div`
  display: none;

  &.expanded {
    display: block;
  }
`;

export const SpinnerContainer = styled.div`
  transform: translate(15%, 30%);
  height: 80%;
  width: 80%;
`;

export const customStyles: StylesConfig<SearchBarOption> = {
  option: (defaultStyles, state) => ({
    ...defaultStyles,
    backgroundColor: state.isFocused ? colours.elexonGreen : colours.white,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 0,
    paddingBottom: 0,
    fontWeight: fonts.normal,
    color: colours.darkGrey,
  }),
  control: (base) => ({
    ...base,
    flexDirection: "row-reverse",
  }),
  menu: (base) => ({
    ...base,
    marginTop: 0,
  }),
  menuList: (base) => ({
    ...base,
    paddingTop: 16,
    paddingBottom: 16,
  }),
};

export const augmentTheme = (theme: Theme): Theme => ({
  ...theme,
  borderRadius: 0,
  colors: {
    ...theme.colors,
    primary: colours.elexonBlue, // Border colour when active
    neutral20: colours.highlightGrey, // Border colour
    neutral30: colours.elexonBlue, // Border colour on hover
  },
});
